import { tw } from "@careinfo/tailwind";
import { Popover, Transition } from "@headlessui/react";
import { Fragment } from "react";
import MenuIcon from "../../../Icons/MenuIcon";

const Delete = (props: any) => {
  const {
    handleClearMessage,
    handleDeleteGroup,
    isDeleting,
    id,
    disabled = false,
  } = props;

  return (
    <div>
      <Popover className={tw`relative`}>
        {({ open, close }) => (
          <>
            <Popover.Button
              disabled={disabled}
              className={tw`group inline-flex items-center  focus:outline-none `}
            >
              <MenuIcon />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                className={tw`absolute z-10 mt-3 max-w-sm w-[160px] px-4 -mx-[130px]`}
              >
                <div className={tw`flex flex-col  bg-white rounded-md `}>
                  <button
                    type="button"
                    disabled={isDeleting || false}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteGroup(id);
                    }}
                    className={tw`hover:text-white text-left hover:bg-primary py-2 focus:outline-none rounded-md px-4`}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    disabled={isDeleting || false}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClearMessage(id);
                    }}
                    className={tw`hover:text-white text-left hover:bg-primary py-2 focus:outline-none rounded-md px-4`}
                  >
                    Clear message
                  </button>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default Delete;
